var module = angular.module('octopusApp.projects');

module.controller('ProjectGroupEditController', function ($scope, $stateParams, busy, pageTitle, octopusRepository, $location) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.projectGroup = null;
    $scope.environments = null;

    var projectGroupId = $stateParams["id"];
    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {

        if (projectGroupId) {
            isLoading.promise(octopusRepository.ProjectGroups.get(projectGroupId).then(function (group) {
                $scope.environments = environments;
                $scope.projectGroup = group;
                pageTitle(group.Name + " settings");
            }));
        } else {
            $scope.environments = environments;
            $scope.projectGroup = {};
            pageTitle("Create project group");
        }
    }));

    $scope.save = function () {
        isSaving.promise(octopusRepository.ProjectGroups.save($scope.projectGroup).then(function (saved) {
            $location.url("/projects" + (!projectGroupId ? "?newProjectGroupId=" + saved.Id : ""));
        }));
    };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/groups/ProjectGroupEdit.js
// module id = 566
// module chunks = 1